export default __webpack_public_path__ + "static/media/actionfigure-qr.70ea1527.svg";